import { Link } from 'react-router-dom';

const EventSection = () => {
  return (
    <section className="bg-[#080C1E] py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden border border-[#C9A227]/20">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/01bb33689838c22877f72885f54c292e.jpg"
              alt="Soirée AD.NOVA.PRO"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#080C1E] via-[#080C1E]/85 to-[#080C1E]/50" />
          </div>

          {/* Content */}
          <div className="relative z-10 p-10 md:p-14 max-w-xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#C9A227]/10 border border-[#C9A227]/30 rounded-full mb-6">
              <span className="w-1.5 h-1.5 rounded-full bg-[#C9A227] animate-pulse inline-block"></span>
              <span className="text-[#C9A227] text-xs font-semibold tracking-widest uppercase">Événement à venir</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-black text-white mb-3 leading-tight">
              Soirée Lancement<br />
              <span className="text-[#C9A227]">AD.NOVA.PRO</span>
            </h2>

            <div className="flex flex-wrap gap-3 mb-6">
              <span className="flex items-center gap-1.5 text-sm text-white/60">
                <i className="ri-map-pin-line text-[#C9A227]"></i>
                Bordeaux
              </span>
              <span className="flex items-center gap-1.5 text-sm text-white/60">
                <i className="ri-calendar-line text-[#C9A227]"></i>
                Mai 2026
              </span>
              <span className="flex items-center gap-1.5 text-sm text-white/60">
                <i className="ri-group-line text-[#C9A227]"></i>
                30 places · Sur invitation
              </span>
              <span className="flex items-center gap-1.5 text-sm text-white/60">
                <i className="ri-price-tag-3-line text-[#C9A227]"></i>
                50€ / personne
              </span>
            </div>

            <p className="text-white/50 text-sm leading-relaxed mb-8">
              Témoignages de reconversions réussies, table ronde avec les experts du réseau,
              networking privé entre profils sélectionnés. Une soirée exclusive pour ceux qui construisent vraiment.
            </p>

            <Link
              to="/auth/signup"
              className="inline-flex items-center gap-2 px-6 py-3 bg-[#C9A227] text-[#080C1E] font-bold rounded-xl hover:bg-[#D4B84A] transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-ticket-line text-base"></i>
              Rejoindre la liste d&apos;attente
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventSection;
